// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import RegistrationStatus from "enums/RegistrationStatus";
import User, { processUser } from "./User";
import Util from "PreciateUtil";

export default interface SocialEvent {
    socialEventId?: string;
    name?: string;
    description?: string;
    eventLink?: string;
    eventColor?: string;
    buttonColor?: string;
    buttonTextColor?: string;
    registrationStatus?: RegistrationStatus;
    validateParticipants?: boolean;
    startDateTime?: Date;
    endDateTime?: Date;
    socialRoomSetId?: string;
    logoImageId?: string;
    logoImageURI?: string;
    user?: User;
}

export function processSocialEvent(value?: SocialEvent): void {
  if (value) {
    value.startDateTime = Util.toDate((value as any).startDateTime);
    value.endDateTime = Util.toDate((value as any).endDateTime);
    processUser(value.user);
  }
}

export function processSocialEventArray(array?: SocialEvent[]): void {
  if (array) {
    for (const v of array) {
      processSocialEvent(v);
    }
  }
}
